import React from 'react';
import { MemberManagement } from '../members/MemberManagement';

export type MembersSectionProps = {
  trainerId: string;
  trainerName: string;
  pendingOpenAddMember?: boolean;
  onPendingOpenAddMemberConsumed?: () => void;
};

export function MembersSection({
  trainerId,
  trainerName,
  pendingOpenAddMember,
  onPendingOpenAddMemberConsumed,
}: MembersSectionProps) {
  return (
    <div style={{ position: 'relative', zIndex: 1 }}>
      <MemberManagement
        trainerId={trainerId}
        trainerName={trainerName}
        pendingOpenAddMember={pendingOpenAddMember}
        onPendingOpenAddMemberConsumed={onPendingOpenAddMemberConsumed}
      />
    </div>
  );
}
